/**
 * Drawer component
 * NOTE: This component its only used in mobile
 * @returns <Drawer />
 */

const Drawer = ({ title, content, isOpen, close }) => {
    return (
        <div className={`drawer ${isOpen ? "--open" : ""}`}>
            <div className="drawer__overlay">
                <div className="drawer__box">
                    <div className="bar bar-small"></div>

                    <div className="drawer__content">
                        <div className="drawer__header">
                            <h3>{title}</h3>

                            <button onClick={close}>
                                <img src={`${window._env_.STATIC_HOST}/static/website/images/icon-close.svg`} alt="" />
                            </button>
                        </div>
                        <div className="drawer__scroll">
                            <div className="drawer__content">
                                {content}
                            </div>
                        </div>

                    </div>

                    <div className="bar__container">
                        <div className="bar bar-big"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Drawer